import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";

import { Layout } from "../data/layout";

@Injectable()
export class LayoutService {
  httpHeaders = new HttpHeaders({ "Content-Type": "application/json" });
  layoutsUrl = "api/v2/layouts";
  headers = { headers: this.httpHeaders };

  constructor(private httpClient: HttpClient) {}

  getLayouts(): Promise<Layout[]> {
    return this.httpClient
      .get(this.layoutsUrl)
      .toPromise()
      .then((response) => response as Layout[])
      .catch(this.handleError);
  }

  getLayout(id: string): Promise<Layout> {
    const url = `${this.layoutsUrl}/${id}`;
    return this.httpClient
      .get(url)
      .toPromise()
      .then((response) => response as Layout)
      .catch(this.handleError);
  }

  delete(id: string): Promise<void> {
    const url = `${this.layoutsUrl}/${id}`;
    return this.httpClient
      .delete(url, this.headers)
      .toPromise()
      .then(() => null)
      .catch(this.handleError);
  }

  create(): Promise<Layout> {
    return this.httpClient
      .post(this.layoutsUrl, { title: "Untitled Layout" }, this.headers)
      .toPromise()
      .then((res) => res as Layout)
      .catch(this.handleError);
  }

  update(layout: Layout): Promise<Layout> {
    const url = `${this.layoutsUrl}/${layout.id}`;
    return this.httpClient
      .put(url, JSON.stringify(layout), this.headers)
      .toPromise()
      .then(() => layout)
      .catch(this.handleError);
  }

  copy(layout: Layout): Promise<Layout> {
    delete layout.id;
    layout.title = layout.title + " (copy)";
    return this.httpClient
      .post(this.layoutsUrl, layout, this.headers)
      .toPromise()
      .then((res) => res as Layout)
      .catch(this.handleError);
  }

  handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}
